var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = (scopeName, key) => {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = (scope, key) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key) => {
	var versions = scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = (scope, key, requiredVersion) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = (scope, scopeName, key, requiredVersion) => {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warn = (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var warnInvalidVersion = (scope, scopeName, key, requiredVersion) => {
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var init = (fn) => (function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
});

var load = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	6151: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/core", [2,16,2,0], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs")]).then(() => (() => (__webpack_require__(1699))))))),
	4817: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/common", [2,16,2,0], () => (__webpack_require__.e("default-node_modules_angular_common_fesm2022_common_mjs").then(() => (() => (__webpack_require__(6575))))))),
	3635: () => (loadStrictSingletonVersionCheckFallback("default", "rxjs", [2,7,8,0], () => (Promise.all([__webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9f2bd5"), __webpack_require__.e("node_modules_rxjs_dist_esm_index_js")]).then(() => (() => (__webpack_require__(2153))))))),
	5893: () => (loadStrictSingletonVersionCheckFallback("default", "rxjs/operators", [2,7,8,0], () => (Promise.all([__webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9f2bd5"), __webpack_require__.e("node_modules_rxjs_dist_esm_operators_index_js")]).then(() => (() => (__webpack_require__(4117))))))),
	4253: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/coercion", [1,16,2,1], () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(5998))))))),
	3355: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/platform", [1,16,2,1], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(3274))))))),
	8491: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/keycodes", [1,16,2,1], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_keycodes_mjs").then(() => (() => (__webpack_require__(554))))))),
	704: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/observers", [1,16,2,1], () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(6787))))))),
	502: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/layout", [1,16,2,1], () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(9743))))))),
	7853: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/bidi", [1,16,2,1], () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(4565))))))),
	2371: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/a11y", [1,16,2,1], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_coercion_angular_cdk_coercion"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_keycodes_angular_cdk_keycodes"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_a11y_mjs")]).then(() => (() => (__webpack_require__(3170))))))),
	1541: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/portal", [1,16,2,1], () => (__webpack_require__.e("default-node_modules_angular_cdk_fesm2022_portal_mjs").then(() => (() => (__webpack_require__(3517))))))),
	1723: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/overlay", [1,16,2,1], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_coercion_angular_cdk_coercion"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_overlay_mjs")]).then(() => (() => (__webpack_require__(2698))))))),
	5929: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/scrolling", [1,16,2,1], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_collections_angular_cdk_collections"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_scrolling_mjs")]).then(() => (() => (__webpack_require__(275))))))),
	5806: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/collections", [1,16,2,1], () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(636))))))),
	6564: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/common/http", [2,16,2,0], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_common_fesm2022_http_mjs")]).then(() => (() => (__webpack_require__(4860))))))),
	2478: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/platform-browser", [2,16,2,0], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-node_modules_angular_platform-browser_fesm2022_platform-browser_mjs")]).then(() => (() => (__webpack_require__(6480))))))),
	202: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/router", [2,16,2,0], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("default-node_modules_angular_router_fesm2022_router_mjs")]).then(() => (() => (__webpack_require__(7947))))))),
	3484: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/forms", [2,16,2,0], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_forms_fesm2022_forms_mjs")]).then(() => (() => (__webpack_require__(8849))))))),
	5251: () => (loadStrictSingletonVersionCheckFallback("default", "ngx-popperjs", [1,16,0,6], () => (__webpack_require__.e("default-node_modules_ngx-popperjs_fesm2022_ngx-popperjs_mjs").then(() => (() => (__webpack_require__(806))))))),
	8019: () => (loadStrictSingletonVersionCheckFallback("default", "lodash", [1,4,17,21], () => (__webpack_require__.e("node_modules_lodash_lodash_js").then(() => (() => (__webpack_require__(7178))))))),
	9889: () => (loadStrictSingletonVersionCheckFallback("default", "ngx-mask", [1,16,2,8], () => (__webpack_require__.e("default-node_modules_ngx-mask_fesm2022_ngx-mask_mjs").then(() => (() => (__webpack_require__(7728))))))),
	8960: () => (loadSingletonVersionCheckFallback("default", "@knoxpo/ui/angular/cdk-icon", [4,0,0,1], () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(7992))))))),
	6032: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/text-field", [1,16,2,1], () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(5802))))))),
	9287: () => (loadStrictSingletonVersionCheckFallback("default", "luxon", [1,3,4,0], () => (__webpack_require__.e("node_modules_luxon_src_luxon_js").then(() => (() => (__webpack_require__(1268))))))),
	4742: () => (loadStrictSingletonVersionCheckFallback("default", "tslib", [1,2,3,0], () => (__webpack_require__.e("node_modules_tslib_tslib_es6_mjs").then(() => (() => (__webpack_require__(2321))))))),
	7098: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/dialog", [1,16,2,1], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_platform_angular_cdk_platform"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_keycodes_angular_cdk_keycodes"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_bidi_angular_cdk_bidi"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_a11y_angular_cdk_a11y"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_portal_angular_cdk_portal"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_dialog_mjs")]).then(() => (() => (__webpack_require__(3108))))))),
	8944: () => (loadSingletonVersionCheckFallback("default", "@knoxpo/ui/angular/cdk", [4,0,0,1], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_coercion_angular_cdk_coercion"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_platform_angular_cdk_platform"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_collections_angular_cdk_collections"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_a11y_angular_cdk_a11y"), __webpack_require__.e("default-libs_angular_cdk_src_index_ts")]).then(() => (() => (__webpack_require__(7970))))))),
	1135: () => (loadStrictSingletonVersionCheckFallback("default", "@faker-js/faker", [1,8,3,1], () => (__webpack_require__.e("node_modules_faker-js_faker_dist_esm_index_mjs").then(() => (() => (__webpack_require__(647)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"default-webpack_sharing_consume_default_angular_core_angular_core": [
		6151
	],
	"default-webpack_sharing_consume_default_angular_common_angular_common": [
		4817
	],
	"default-webpack_sharing_consume_default_rxjs_rxjs": [
		3635
	],
	"default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators": [
		5893
	],
	"default-webpack_sharing_consume_default_angular_cdk_coercion_angular_cdk_coercion": [
		4253
	],
	"default-webpack_sharing_consume_default_angular_cdk_platform_angular_cdk_platform": [
		3355
	],
	"default-webpack_sharing_consume_default_angular_cdk_keycodes_angular_cdk_keycodes": [
		8491
	],
	"default-node_modules_angular_cdk_fesm2022_a11y_mjs": [
		704,
		502
	],
	"default-webpack_sharing_consume_default_angular_cdk_bidi_angular_cdk_bidi": [
		7853
	],
	"default-webpack_sharing_consume_default_angular_cdk_a11y_angular_cdk_a11y": [
		2371
	],
	"default-webpack_sharing_consume_default_angular_cdk_portal_angular_cdk_portal": [
		1541
	],
	"default-node_modules_angular_cdk_fesm2022_dialog_mjs": [
		1723
	],
	"default-node_modules_angular_cdk_fesm2022_overlay_mjs": [
		5929
	],
	"default-webpack_sharing_consume_default_angular_cdk_collections_angular_cdk_collections": [
		5806
	],
	"default-webpack_sharing_consume_default_angular_common_http_angular_common_http": [
		6564
	],
	"default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser": [
		2478
	],
	"default-webpack_sharing_consume_default_angular_router_angular_router": [
		202
	],
	"default-webpack_sharing_consume_default_angular_forms_angular_forms": [
		3484
	],
	"default-webpack_sharing_consume_default_lodash_lodash-webpack_sharing_consume_default_ngx-pop-03e68f": [
		5251,
		8019
	],
	"default-libs_angular_cdk_src_index_ts": [
		9889,
		8960,
		6032,
		9287
	],
	"default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9f2bd5": [
		4742
	],
	"apps_micro-apps_business_src_bootstrap_ts": [
		6151
	],
	"default-apps_micro-apps_business_src_app_main-entry_entry_module_ts": [
		7098,
		8944,
		1135
	],
	"webpack_sharing_consume_default_angular_common_http_angular_common_http-webpack_sharing_consu-dbf4ef": [
		6564,
		3635
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
		});
	}
}